import { render, staticRenderFns } from "./GibUserRequest.vue?vue&type=template&id=6ae68b1e&"
import script from "./GibUserRequest.vue?vue&type=script&lang=js&"
export * from "./GibUserRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports